jQuery_T4NT(document).ready(function($) {
   $('.key_hightlights_images-wrapper').slick({
   slidesToShow: 2,
   slidesToScroll: 1,
     infinite:true,
   dots: false,
    prevArrow:'<button class="slick-prev btn btn-white rounded-circle"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M3.77067 8.81135L10.3707 2.31313L8.48533 0.456873L3.70906e-07 8.81135L8.48534 17.1658L10.3707 15.3096L3.77067 8.81135Z" fill="#212B5D"></path></svg></button>',
     nextArrow:'<button class="slick-next btn btn-white rounded-circle"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M3.77067 8.81135L10.3707 2.31313L8.48533 0.456873L3.70906e-07 8.81135L8.48534 17.1658L10.3707 15.3096L3.77067 8.81135Z" fill="#212B5D"></path></svg></button>',
       responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
 });

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
	$(document).on('click', '.t4s-viewall-demos-btn', function (event) {
		$.magnificPopupT4s.open({
			items: {
				src: '#t4s-theme__demo',
				type: 'inline'
			}
		});
	});


});